var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"session-timeout-error"},[_c('div',{staticClass:"timeout-message"},[_c('h1',[_vm._v("This Link Has Expired")]),_c('p',[_vm._v("Please request new link from property manager.")])])])
}]

export { render, staticRenderFns }